import { Outlet } from "react-router-dom"





const Invoices = () => {

    return (
        <div>
            <Outlet />
        </div>
    )
}

export default Invoices;